/* unplugin-vue-components disabled */import script from "./action.vue?vue&type=script&setup=true&lang=ts"
export * from "./action.vue?vue&type=script&setup=true&lang=ts"

import "./action.vue?vue&type=style&index=0&id=26c74e12&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-26c74e12"]])

export default __exports__